import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import {
    useFetchUserByUserTypeMutation,
    useFetchUserByUserTypeCountMutation,
} from "../../../features/tenant/appUsers/appUsersApi";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";

const DistributorWiseScanning = () => {
    const { zone_id: zoneId } = getLoginUserData();
    const navigate = useNavigate();

    const [myList, setMyList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [csvData, setCsvData] = useState(null);

    const initialRequest = {
        user_type_id: 3, // Distributor type
        email: "",
        limit: 10,
        offset: 0,
        mobile: "",
        name: "",
        user_id: "",
        startDate: "",
        endDate: "",
        status: "",
        state: "",
        city: "",
    };

    const initialRequestCount = {
        user_type_id: 3,
        email: "",
        mobile: "",
        name: "",
        user_id: "",
        startDate: "",
        endDate: "",
        state: "",
        city: "",
    };

    const [request, setRequest] = useState(initialRequest);
    const [requestCount, setRequestCount] = useState(initialRequestCount);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const [
        fetchDistributors,
        { data: distributorsData, error: distributorsError, isLoading: distributorsIsLoading },
    ] = useFetchUserByUserTypeMutation();

    const [
        fetchDistributorsCount,
        { data: distributorsCountData, error: distributorsCountError },
    ] = useFetchUserByUserTypeCountMutation();

    const [
        fetchDistributorCsv,
        { data: distributorsCsvData, error: distributorsCsvError },
    ] = useFetchUserByUserTypeMutation();

    useEffect(() => {
        fetchDistributorsCount({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: requestCount,
            zoneId: zoneId,
        });
    }, [requestCount]);

    useEffect(() => {
        if (distributorsCountData) {
            setTotalRows(
                distributorsCountData && distributorsCountData?.body?.total
                    ? distributorsCountData?.body?.total
                    : 0
            );
        }
    }, [distributorsCountData, distributorsCountError]);

    const fetchDistributorsFunction = (req = request) => {
        req["limit"] = limit;
        req["offset"] = offset;

        fetchDistributors({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: req,
            zoneId: zoneId,
        });
    };

    const fetchDistributorsCsvFunction = () => {
        const modifiedRequest = {
            ...request,
            limit: null,
            offset: null,
            export: true,
        };
        fetchDistributorCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: modifiedRequest,
            zoneId: zoneId,
        });
    };

    const clearFilters = () => {
        setRequest(initialRequest);
        fetchDistributorsFunction(initialRequest);
    };

    useEffect(() => {
        fetchDistributorsFunction();

        let tempRequest = { ...request };
        delete tempRequest.limit;
        delete tempRequest.offset;

        if (JSON.stringify(tempRequest) !== JSON.stringify(requestCount)) {
            setRequestCount(tempRequest);
        }
    }, [limit, offset]);

    useEffect(() => {
        if (distributorsData) {
            setMyList(
                distributorsData && distributorsData.body && distributorsData.body.appUsersList
                    ? distributorsData.body.appUsersList
                    : []
            );
        }
    }, [distributorsData, distributorsError]);

    useEffect(() => {
        if (distributorsCsvData && distributorsCsvData?.body?.appUsersList) {
            setCsvData(distributorsCsvData?.body.appUsersList);
        }
        if (distributorsCsvError) {
            setCsvData(null);
        }
    }, [distributorsCsvData, distributorsCsvError]);

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest({ ...request, offset: newOffset });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setRequest({ ...request, limit: newPerPage });
    };

    const handleViewRetailers = (distributor) => {
        navigate(`/genefied/${JSON.parse(sessionStorage.getItem("vendorData")).tenant_name}/distributor-retailer-mapping/${distributor.id}`, {
            state: { distributor }
        });
    };

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "70px",
        },
        {
            name: "Profile Pic",
            cell: (row) =>
                row.profile_pic && (
                    <div className="w-12 h-12 my-2 flex justify-center items-center rounded-full">
                        <img
                            src={row.profile_pic}
                            alt="profile"
                            className="rounded-full h-full w-full"
                        />
                    </div>
                ),
            maxWidth: "120px",
        },
        {
            name: "Name",
            cell: (row) => (
                <div>
                    <h2>
                        {row.name}
                    </h2>
                </div>
            ),
            sortable: true,
            width: "200px",
        },
        {
            name: "Mobile",
            cell: (row) => row.mobile,
            sortable: true,
            width: "120px",
        },
        {
            name: "Shop Name",
            cell: (row) => row.firm_name,
            sortable: true,
            width: "150px",
        },
        {
            name: "City",
            cell: (row) => row.city,
            sortable: true,
            minWidth: "120px",
        },
        {
            name: "State",
            cell: (row) => row.state,
            sortable: true,
            minWidth: "120px",
        },
        {
            name: "Registration Date",
            cell: (row) => (
                <div className="flex">
                    <span className="mr-2 w-fit">
                        {new Date(row.enrollment_date).toLocaleDateString()}
                    </span>
                </div>
            ),
            sortable: true,
            minWidth: "180px",
        },
        {
            name: "Status",
            cell: (row) =>
                row.status == "1" ? (
                    <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded">
                        Active
                    </span>
                ) : (
                    <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded">
                        Inactive
                    </span>
                ),
        },
        {
            name: "View Retailers",
            cell: (row) => (
                <button
                    onClick={() => handleViewRetailers(row)}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-sm"
                >
                    View Scans
                </button>
            ),
            minWidth: "150px",
        },
    ];

    return (
        <div className="flex w-full bg-gray-200 h-full justify-center">
            <div className="w-full">
                <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                    Distributor Wise Scanning
                    <LinksComponent />
                </div>

                <div className="p-3">

                    <div className="w-full bg-white shadow rounded-lg">
                        {distributorsIsLoading && <CircleLoaderComponent />}
                        <DataTableComponent
                            keyField={(row) => row.id}
                            columns={columns}
                            paginationResetDefaultPage={resetPaginationToggle}
                            data={myList}
                            totalRows={totalRows}
                            handlePerRowsChange={handlePerRowsChange}
                            handlePageChange={handlePageChange}
                        >
                            <div className="border-b border-gray-300 bg-gray-50 rounded-t-lg p-3">
                                <div className="flex space-x-2 justify-end">
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Mobile
                                            </label>
                                            <input
                                                type="search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Mobile..."
                                                value={request.mobile}
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        mobile: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Name
                                            </label>
                                            <input
                                                type="search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Name..."
                                                value={request.name}
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        name: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Email
                                            </label>
                                            <input
                                                type="search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Email..."
                                                value={request.email}
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        email: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                User Id
                                            </label>
                                            <input
                                                type="search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="User Id..."
                                                value={request.user_id}
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        user_id: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Status
                                            </label>
                                            <select
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        status: e.target.value,
                                                    }));
                                                }}
                                                value={request.status}
                                            >
                                                <option value="">All</option>
                                                <option value="1">Active</option>
                                                <option value="2">Inactive</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="w-32 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Start Date
                                            </label>
                                            <input
                                                type="date"
                                                className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                value={request.startDate}
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        startDate: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-44 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                End Date
                                            </label>
                                            <input
                                                type="date"
                                                className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                value={request.endDate}
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        endDate: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                State
                                            </label>
                                            <input
                                                type="search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="State"
                                                value={request.state}
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        state: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                City
                                            </label>
                                            <input
                                                type="search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="City"
                                                value={request.city}
                                                onChange={(e) => {
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        city: e.target.value,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex flex-row gap-2 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right p-2"
                                                onClick={() => {
                                                    fetchDistributorsFunction();
                                                }}
                                            >
                                                Search
                                            </button>
                                        </div>
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right p-2"
                                                onClick={() => {
                                                    clearFilters();
                                                }}
                                            >
                                                Clear Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </DataTableComponent>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default DistributorWiseScanning;
